export default {"src":"/_next/static/media/send.c8ccac3e.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};